import React from 'react'
import Grid from '@mui/material/Grid2'
import { useTranslation } from 'react-i18next'
import { ILeisureActivity } from 'types/cvsInterfaces'
import { chooseDBTranslation } from 'utils/translations'
import { convertToDisplayDate } from 'utils/utils'
import withProfileCardItem from 'Components/reusable/HOC/withProfileCardItem'
import CardContentText from 'Components/reusable/CaleoCustomComponents/CardContentText'
import ExtendedCardContent from 'Components/reusable/CaleoCustomComponents/ExtendedCardContent'

interface ILeisureActivityItemCardProps {
  item: ILeisureActivity
}

const LeisureActivityItemCard: React.FC<ILeisureActivityItemCardProps> = ({ item }) => {
  const { t, i18n } = useTranslation()
  const tr = chooseDBTranslation(i18n, item)

  const hasDate = !!item.startDate || !!item.endDate
  const dateText = hasDate
    ? `${item.startDate ? convertToDisplayDate(item.startDate, item.dateResolution) : ''}${item.startDate || item.endDate ? ' - ' : ''}${item.endDate ? convertToDisplayDate(item.endDate, item.dateResolution) : ''}`
    : ''

  return (
    <ExtendedCardContent description={tr?.description}>
      <CardContentText type={'header'}>{tr?.name}</CardContentText>
      {!!tr?.activityType && (
        <Grid>
          <CardContentText fontWeight={'bold'}>
            {t('profile.leisureActivity.modal.activityType')}
            {': '}
          </CardContentText>
          <CardContentText>{tr.activityType}</CardContentText>
        </Grid>
      )}
      {!!dateText && (
        <Grid>
          <CardContentText fontWeight={'bold'}>
            {t('profile.leisureActivity.modal.dateRange')}
            {': '}
          </CardContentText>
          <CardContentText>{dateText}</CardContentText>
        </Grid>
      )}
    </ExtendedCardContent>
  )
}

export default withProfileCardItem(LeisureActivityItemCard)
